import InitLayout from '../layout/InitLayout';

const AccessDeny = () => {

    return (
        <InitLayout>
            <div className='init__content access-deny'>
                <h1>Access Denied</h1>
                <p>Your access to this page has been denied. <br /> If this is in error, please contact your local administrator or NIET customer support.</p>
            </div>
        </InitLayout>
    );

};

export default AccessDeny;
